import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StatiManutenzioneFormComponent } from './dialogs/form/form.component';
import { StatiManutenzioneComponent } from './stati-manutenzione.component';


const routes: Routes = [
  {
    path: '', component: StatiManutenzioneComponent
  },
  {
    path: 'inserisci', component: StatiManutenzioneFormComponent,
    data: { title: 'Inserimento StatiManutenzione' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StatiManutenzioneRoutingModule { }
